import { render } from "./CreatePaymentLiquidation3.vue?vue&type=template&id=85e06258"
import script from "./CreatePaymentLiquidation3.vue?vue&type=script&lang=js"
export * from "./CreatePaymentLiquidation3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__